import { createStandardAction } from 'typesafe-actions';
import { WeekAtAGlanceActionPayload } from './types';

export const setWeekAtAGlanceWeek = createStandardAction(
  'APP/SET_WEEK_AT_A_GLANCE_WEEK'
)<WeekAtAGlanceActionPayload>();
